import { LogOut } from 'lucide-react';
import { signOut } from 'aws-amplify/auth';
import type { Me } from '../api/me';

export default function TopBar({ me }: { me: Me }) {
  return (
    <header className="sticky top-0 z-20 h-12 bg-deep text-white flex items-center justify-between px-4 sm:px-6">
      <span className="text-lg font-bold tracking-tight">
        habitania <span className="text-leaf text-xs font-semibold tracking-widest ml-1">CRM</span>
      </span>
      <div className="flex items-center gap-3 text-xs text-white/70">
        <span className="hidden sm:block">{me.email}</span>
        <span className="rounded-full bg-leaf/20 text-leaf px-2 py-0.5 font-semibold uppercase tracking-wider">
          {me.groups.includes('admin') ? 'admin' : 'agente'}
        </span>
        <button
          onClick={() => signOut()}
          aria-label="Cerrar sesión"
          className="hover:text-white transition p-1"
        >
          <LogOut size={16} />
        </button>
      </div>
    </header>
  );
}
